import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/descriptions/style";
import _Descriptions from "antd/lib/descriptions";
import "antd/lib/radio/style";
import _Radio from "antd/lib/radio";
import "antd/lib/divider/style";
import _Divider from "antd/lib/divider";
import "antd/lib/row/style";
import _Row from "antd/lib/row";
import "antd/lib/col/style";
import _Col from "antd/lib/col";
import "antd/lib/checkbox/style";
import _Checkbox from "antd/lib/checkbox";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty"; /*@技术支持-FullMesh链路*/
import React from 'react';
import * as echarts from "echarts";
import { parse, statusMap, LinkType } from "../../../utils/commonUtilFunc";
import './index.scss'; // import moment from 'moment';
import TunnelInfo from "../../MI/MI0104/subComponents/TunnelInfo";
import LinkCharts from './LinkCharts';
import noWan from '../../../assets/img/noWan.png';
var BI0802C = /*#__PURE__*/function (_React$Component) {
  _inherits(BI0802C, _React$Component);
  function BI0802C(props) {
    var _this;
    _classCallCheck(this, BI0802C);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(BI0802C).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_fullmesh_link_detail", function () {
      var payload = _this.state.device_id ? {
        device_id: _this.state.device_id,
        status: _this.state.ifAllLinkShow ? "" : "ONLINE"
      } : {
        fml_id: _this.fml_id,
        status: _this.state.ifAllLinkShow ? "" : "ONLINE"
      };
      _this.props.dispatch({
        type: "bi0802Info/get_fullmesh_link_detail",
        payload: payload
      }).then(function () {
        var pairName = _this.props.bi0802Info.pairs.filter(function (item) {
          return item.is_current;
        })[0];
        _this.setState({
          pairName: pairName && pairName.name ? pairName.name : '',
          detailData: pairName && pairName.link ? pairName.link : '',
          dataType: 'edge'
        });
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleRttShow", function (e) {
      _this.setState({
        ifRttShow: e.target.checked
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleAllLinkShow", function (e) {
      _this.setState({
        ifAllLinkShow: e.target.checked
      }, function () {
        _this.get_fullmesh_link_detail();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLinkInfoModalShow", function (params) {
      _this.setState({
        linkInfoModalShow: true,
        showTooltip: false,
        link_id: params.data.link_id,
        bandwidth: params.data.bandwidth,
        sn: params.data.sn
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleLinkInfoModalClose", function () {
      _this.setState({
        linkInfoModalShow: false,
        link_id: "",
        bandwidth: 0,
        sn: "",
        showTooltip: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChart", function () {
      // let that = this;
      var option = {
        series: [{
          name: 'Fullmesh Graph',
          type: 'graph',
          layout: 'force',
          circular: {
            rotateLabel: true
          },
          force: {
            edgeLength: 300,
            repulsion: 2000
          },
          data: _this.props.bi0802Info.fullmeshNodeInfo,
          links: _this.props.bi0802Info.fullmeshLinkInfo,
          roam: true,
          label: {
            normal: {
              show: true,
              position: 'top',
              color: "#000",
              fontSize: 14,
              fontFamily: "PingFangSC-Regular"
            }
          },
          edgeLabel: {
            normal: {
              show: _this.state.ifRttShow,
              textStyle: {
                fontSize: 12,
                color: "rgba(0,0,0,0.85)"
              },
              formatter: "rtt: {c}"
            }
          },
          lineStyle: {
            normal: {
              color: 'source',
              curveness: 0
            }
          }
        }]
      };
      _this.topoGraph.setOption(option);
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (e) {
      var pairName = _this.props.bi0802Info.pairs.filter(function (item) {
        return item.name === e.target.value;
      })[0];
      _this.setState({
        pairName: pairName && pairName.name ? pairName.name : '',
        detailData: pairName && pairName.link ? pairName.link : '',
        dataType: 'edge'
      });
    });
    _this.state = {
      ifRttShow: false,
      ifAllLinkShow: true,
      linkInfoModalShow: false,
      showTooltip: true,
      link_id: "",
      bandwidth: 0,
      sn: "",
      detailData: {},
      dataType: '',
      pairName: '',
      device_id: _this.props.device_id
    };
    _this.fml_id = _this.props.location && _this.props.location.search ? parse(_this.props.location.search).fml_id : _this.props.fml_id;
    _this.isCustom = sessionStorage.getItem("role") === "companystaff" || sessionStorage.getItem("role") === 'company';
    return _this;
  }
  _createClass(BI0802C, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.get_fullmesh_link_detail(this.state["if"]); // this.topoGraph = echarts.init(document.getElementById("topo-graph"));
      // this.topoGraph.on('click', (e) => {
      //     this.setState({
      //         dataType: e.dataType,
      //         detailData: e.data,
      //     })
      // })
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      if (document.getElementById("topo-graph")) {
        this.topoGraph = echarts.init(document.getElementById("topo-graph"));
        this.topoGraph.on('click', function (e) {
          _this2.setState({
            dataType: e.dataType,
            detailData: e.data
          });
        });
        this.renderChart();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;
      if (this.props.device_id !== nextProps.device_id) {
        this.setState({
          device_id: nextProps.device_id
        }, function () {
          _this3.get_fullmesh_link_detail();
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        detailData = _this$state.detailData,
        dataType = _this$state.dataType,
        pairName = _this$state.pairName;
      var linkChartsProps = _objectSpread({}, detailData);
      return /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, this.props.bi0802Info.fullmeshNodeInfo.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement(_Row, {
        className: "fulldetailright"
      }, /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React.createElement(_Checkbox, {
        checked: this.state.ifRttShow,
        onChange: this.handleRttShow
      }, "Display RTT")), /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React.createElement(_Checkbox, {
        checked: this.state.ifAllLinkShow,
        onChange: this.handleAllLinkShow
      }, "Show all links")))), /*#__PURE__*/React.createElement(_Divider, null), /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React.createElement("div", {
        id: "topo-graph",
        style: {
          width: '100%',
          height: 400,
          display: this.state.showTooltip ? "block" : "none"
        }
      })), /*#__PURE__*/React.createElement(_Col, {
        span: 12
      }, /*#__PURE__*/React.createElement("div", {
        className: "fullMeshLinkDetail"
      }, /*#__PURE__*/React.createElement(_Radio.Group, {
        value: pairName,
        onChange: this.handleChange
      }, this.props.bi0802Info.pairs.map(function (item) {
        return /*#__PURE__*/React.createElement(_Radio, {
          value: item.name,
          key: item.name
        }, item.name);
      })), dataType === 'node' ? /*#__PURE__*/React.createElement(_Descriptions, {
        title: "Device Information",
        column: 1
      }, /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Device Name"
      }, detailData.name), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "state"
      }, statusMap(detailData.status)), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Hardware ID"
      }, detailData.sn), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Private IP segment"
      }, detailData.ipset)) : /*#__PURE__*/React.createElement(_Descriptions, {
        title: "Link information",
        column: 1
      }, /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Link ID"
      }, detailData.link_id), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "state"
      }, statusMap(detailData.status)), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Tunnel type"
      }, detailData.link_source ? detailData.link_source === "fullmesh_dynamic" ? "Dynamic link" : "Static link" : ""), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Service level"
      }, LinkType(detailData.grade)), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Shared bandwidth"
      }, detailData.bandwidth), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Edge nodes"
      }, detailData.source), /*#__PURE__*/React.createElement(_Descriptions.Item, {
        label: "Central node"
      }, detailData.target))))), /*#__PURE__*/React.createElement(_Divider, null), linkChartsProps.link_id ? /*#__PURE__*/React.createElement(LinkCharts, {
        linkInfo: linkChartsProps
      }) : '', /*#__PURE__*/React.createElement(_Modal, {
        visible: this.state.linkInfoModalShow,
        onCancel: this.handleLinkInfoModalClose,
        title: "Tunnel information",
        width: 1000,
        footer: null
      }, /*#__PURE__*/React.createElement(TunnelInfo, {
        bandwidth: this.state.bandwidth,
        sn: this.state.sn,
        link_id: this.state.link_id,
        company_id: this.state.company_id
      }))) : /*#__PURE__*/React.createElement("div", {
        style: {
          textAlign: 'center'
        }
      }, /*#__PURE__*/React.createElement("img", {
        src: noWan,
        alt: "\u6682\u65E0\u6570\u636E"
      })));
    }
  }]);
  return BI0802C;
}(React.Component);
export default BI0802C;